export function getXsrfToken() {
    const entries = document.cookie.split('; ').map(part => part.split('='));
    const matchingEntry = entries.find(entry => entry[0] === 'XSRF-TOKEN');
    return matchingEntry ? matchingEntry[1] : null;
}
